document.addEventListener( 'DOMContentLoaded', function () {
	const popup = document.querySelector( '[data-event-popup]' );

	if ( ! popup ) {
		return;
	}

	const overlay    = popup.querySelector( '[data-event-popup-overlay]' );
	const panel      = popup.querySelector( '.event-popup__panel' );
	const closeBtn   = popup.querySelector( '[data-event-popup-close]' );
	const switcherEl = popup.querySelector( '[data-event-popup-switcher]' );
	const contentEl  = popup.querySelector( '[data-event-popup-content]' );
	const body       = document.body;
	const html       = document.documentElement;

	const syncFixedElementsOffset = ( isOpen ) => {
		if ( isOpen ) {
			const scrollbarWidth = window.innerWidth - html.clientWidth;

			html.style.setProperty( '--fancybox-scrollbar-compensate', `${Math.max( 0, scrollbarWidth )}px` );
			html.classList.add( 'with-fancybox' );
			return;
		}

		html.classList.remove( 'with-fancybox' );
		html.style.removeProperty( '--fancybox-scrollbar-compensate' );
	};

	const clearPopup = () => {
		if ( contentEl ) {
			contentEl.innerHTML = '';
		}

		if ( switcherEl ) {
			switcherEl.innerHTML = '';
			switcherEl.hidden    = true;
		}
	};

	const setPopupState = ( isOpen ) => {
		popup.classList.toggle( 'is-open', isOpen );
		popup.setAttribute( 'aria-hidden', isOpen ? 'false' : 'true' );
		overlay?.classList.toggle( 'is-open', isOpen );
		panel?.classList.toggle( 'is-open', isOpen );

		syncFixedElementsOffset( isOpen );
		body.classList.toggle( 'no-scroll', isOpen );
		body.style.overflow = isOpen ? 'hidden' : '';

		if ( ! isOpen ) {
			clearPopup();
		}
	};

	const loadEventContent = ( eventId ) => {
		const template = document.getElementById( `event-popup-content-${eventId}` );

		if ( ! template || ! contentEl ) {
			return false;
		}

		contentEl.innerHTML = template.innerHTML;

		if ( switcherEl ) {
			switcherEl.querySelectorAll( '[data-event-popup-switch]' ).forEach( ( button ) => {
				const isActive = button.dataset.eventPopupSwitch === eventId;

				button.classList.toggle( 'is-active', isActive );
				button.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
			} );
		}

		return true;
	};

	const renderSwitcher = ( eventIds, currentEventId ) => {
		if ( ! switcherEl || eventIds.length <= 1 ) {
			if ( switcherEl ) {
				switcherEl.innerHTML = '';
				switcherEl.hidden    = true;
			}

			return;
		}

		switcherEl.hidden = false;
		switcherEl.setAttribute( 'role', 'tablist' );
		switcherEl.setAttribute( 'aria-label', 'События дня' );
		switcherEl.innerHTML = eventIds.map( ( eventId, index ) => {
			const isActive = eventId === currentEventId;

			return `
				<button
					type="button"
					class="event-popup__switcher-item${isActive ? ' is-active' : ''}"
					data-event-popup-switch="${eventId}"
					role="tab"
					aria-selected="${isActive ? 'true' : 'false'}"
				>Событие №&nbsp;${index + 1}</button>
			`;
		} ).join( '' );
	};

	const openPopup = ( eventId, eventIds = [] ) => {
		const ids = eventIds.length ? eventIds : [ eventId ];

		renderSwitcher( ids, eventId );

		if ( ! loadEventContent( eventId ) ) {
			return;
		}

		setPopupState( true );
		closeBtn?.focus();
	};

	document.addEventListener( 'click', ( event ) => {
		const switchButton = event.target.closest( '[data-event-popup-switch]' );

		if ( switchButton && popup.contains( switchButton ) ) {
			event.preventDefault();
			loadEventContent( switchButton.dataset.eventPopupSwitch );
			return;
		}

		const trigger = event.target.closest( '[data-event-popup-trigger]' );

		if ( ! trigger ) {
			return;
		}

		event.preventDefault();

		const eventsEl = trigger.closest( '[data-home-calendar-events]' );
		const eventIds = eventsEl?.dataset.eventIds
			? eventsEl.dataset.eventIds.split( ',' ).filter( Boolean )
			: [ trigger.dataset.eventId ];

		openPopup( trigger.dataset.eventId, eventIds );
	} );

	overlay?.addEventListener( 'click', () => {
		setPopupState( false );
	} );

	closeBtn?.addEventListener( 'click', () => {
		setPopupState( false );
	} );

	document.addEventListener( 'keydown', ( event ) => {
		if ( event.key === 'Escape' && popup.classList.contains( 'is-open' ) ) {
			setPopupState( false );
		}
	} );
} );
